function toggleReadMore(button) {
    // Use jQuery to find the closest .listicle-merchant container
    var overlayDiv = $(button).parent();
    var containerDiv = $(button).parent().prev('.listicle-merchant');
    var hrElements = $(overlayDiv).find('hr');

    // Toggle the hr elements
    hrElements.toggleClass('listicle-merchant__hr--read-more');
    hrElements.toggleClass('listicle-merchant__hr--read-less');

    // Toggle the gradient overlay
    overlayDiv.toggleClass('listicle-merchant__gradient-overlay--read-more');
    overlayDiv.toggleClass('listicle-merchant__gradient-overlay--read-less');

    // Toggle the button
    $(button).toggleClass('listicle-merchant__button--read-more');
    $(button).toggleClass('listicle-merchant__button--read-less');
    var checkMaxHeight = $(containerDiv).attr('data-max-height');
    if (!containerDiv.hasClass('collapsed') && (typeof checkMaxHeight === 'undefined' || checkMaxHeight === false)) {
        var realHeight = containerDiv.outerHeight() + 20;
        containerDiv.attr('data-max-height', realHeight + "px");
        console.log('setting max-height to: ', realHeight + "px")
        containerDiv.css('max-height', realHeight + "px");
    }
    maxHeight = "5000px"
    
    // For some browsers, `attr` is undefined; for others,
    // `attr` is false.  Check for both.
    if (typeof checkMaxHeight !== 'undefined' && checkMaxHeight !== false) {
        maxHeight = checkMaxHeight
    }
    
    setTimeout(function () {
        containerDiv.toggleClass('collapsed');
        if (containerDiv.hasClass('collapsed')) {
            $(button).html('<i class="fa fa-chevron-down listicle-merchant__icon--read listicle-merchant__icon--read-more"></i>Read More');
        } else {
            $(button).html('<i class="fa fa-chevron-up listicle-merchant__icon--read listicle-merchant__icon--read-less"></i>Read Less');
            containerDiv.css('max-height', maxHeight);
            // // Solution 1: setTimeout after 2 seconds
            if(typeof checkMaxHeight == 'undefined' || checkMaxHeight === false) {
                setTimeout(function () {
                    containerDiv.removeAttr("style")
                }, 2000);
            }
            
        }
    }, 10);

    // // Solution 2: Check if all the images are loaded
    // // Incase there are images lazy loaded, which take more than 2 seconds to be loaded. Then we need to check all the images inside the containerDiv to see if they are loaded or not.
    // if (containerDiv.hasClass('collapsed') == false && containerDiv.find('img').length > 0) {
    //     // Only check if the containerDiv is expanded and have images inside which are not loaded yet
    //     // Check if all the images are loaded
    //     let images = containerDiv.find('img');
    //     images.each(function () {
    //         // if have any image that is not loaded yet, then do this
    //         if (this.complete == false) {
    //             checkImageLoaded(containerDiv);
    //         } else {
    //             return;
    //         }
    //     });
    // }

    function checkImageLoaded(containerDiv) {
        const checkImageInterval = setInterval(function () {

            let imagesLoaded = true;

        if (containerDiv.hasClass('collapsed') == false) {
            // Get all the images inside the containerDiv
            let images = containerDiv.find('img');

            // Check if all the images are loaded
            images.each(function () {
                if (!this.complete) {
                    imagesLoaded = false;
                    return false; // Break out of the .each loop if an image is not loaded
                }
            });

            if (imagesLoaded) {
                clearInterval(checkImageInterval);
                // recalculate the height of the containerDiv and contentArea to make sure no content is cut off
                console.log('MerchantReadMore said: recalculating height...');
                let contentArea = containerDiv.find('.listicle-merchant__content-area');
                let contentAreaHeight = contentArea.outerHeight(true);
                containerDiv.css('max-height', contentAreaHeight);
            }
            }
        }, 500);
    }

}

// Keep this code here for easier debugging the CSS and HTML if needed
// jQuery(document).ready(function ($) {
//     $('.listicle-merchant').each(function () {
//         let containerDiv = $(this);
//         let containerClass = 'listicle-merchant';

//         // let contentArea = containerDiv.find('.listicle-merchant__content-area');
//         // if (contentArea.outerHeight(true) <= 850) {
//         //     let merchant_name = containerDiv.find('h2, h3').first().text();
//         //     console.log('MerchantReadMore said: ', merchant_name + ' is not expanded');
//         //     return;
//         // }

//         // Modify the button HTML to include the onClick event
//         let html = '<div class="' + containerClass + '__gradient-overlay ' + containerClass + '__gradient-overlay--read-more">';
//         html += '<hr class="' + containerClass + '__hr--read ' + containerClass + '__hr--read-more"/>';
//         html += '<button onclick="toggleReadMore(this)" class="' + containerClass + '__button ' + containerClass + '__button--read ' + containerClass + '__button--read-more">';
//         html += '<i class="fa fa-chevron-down ' + containerClass + '__icon--read ' + containerClass + '__icon--read-more"></i>';
//         html += 'Read More';
//         html += '</button>';
//         html += '<hr class="' + containerClass + '__hr--read ' + containerClass + '__hr--read-more"/>';
//         html += '</div>';

//         // Append the button and its surrounding elements after the container
//         containerDiv.after(html);
//     });
// });

// Add this to the global scope, so that it can be called from the HTML page, not just from webpack's index.js
window.toggleReadMore = toggleReadMore;
